// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incoming-table {
  font-size: 11px !important;
}

.incoming-table th,
.incoming-table td {
  font-size: 11px !important;
}

.incoming-table th.tableheader-txt,
.incoming-table td.tabledata-txt {
  font-size: 11px !important;
}

.incoming-table th:nth-child(7),
.incoming-table td:nth-child(7) {
  width: 6% !important;
  min-width: 60px !important;
}

.incoming-table th:nth-child(8),
.incoming-table td:nth-child(8) {
  width: 8% !important;
  min-width: 80px !important;
}

.incoming-table-hgo th:nth-child(6),
.incoming-table-hgo td:nth-child(6) {
  width: 5% !important;
  min-width: 50px !important;
  max-width: 60px !important;
}

.date-time-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}

.date-time-cell .time {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  min-width: 70px;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-done {
  background-color: #d1e7dd;
  color: #0f5132;
}

.actions-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

/* Monazam Portal - Actions column width for 1024px+ screens */
@media (min-width: 1024px) {
  .incoming-table th:nth-child(9),
  .incoming-table td:nth-child(9) {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/Incoming/IncomingComponents/Table.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF","sourcesContent":[".incoming-table {\n  font-size: 11px !important;\n}\n\n.incoming-table th,\n.incoming-table td {\n  font-size: 11px !important;\n}\n\n.incoming-table th.tableheader-txt,\n.incoming-table td.tabledata-txt {\n  font-size: 11px !important;\n}\n\n.incoming-table th:nth-child(7),\n.incoming-table td:nth-child(7) {\n  width: 6% !important;\n  min-width: 60px !important;\n}\n\n.incoming-table th:nth-child(8),\n.incoming-table td:nth-child(8) {\n  width: 8% !important;\n  min-width: 80px !important;\n}\n\n.incoming-table-hgo th:nth-child(6),\n.incoming-table-hgo td:nth-child(6) {\n  width: 5% !important;\n  min-width: 50px !important;\n  max-width: 60px !important;\n}\n\n.date-time-cell {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.4;\n}\n\n.date-time-cell .time {\n  font-size: 11px;\n  color: #6c757d;\n  margin-top: 2px;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n  text-align: center;\n  min-width: 70px;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-done {\n  background-color: #d1e7dd;\n  color: #0f5132;\n}\n\n.actions-cell {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n}\n\n/* Monazam Portal - Actions column width for 1024px+ screens */\n@media (min-width: 1024px) {\n  .incoming-table th:nth-child(9),\n  .incoming-table td:nth-child(9) {\n    width: 200px !important;\n    min-width: 200px !important;\n    max-width: 200px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
